import { Platform } from "@/constants/platform/platform"

type PlatformConfig = {
  title: string
  urlString: string
  textColor: string
  bgColor: string
  hasReviews: boolean
  urlFilter?: string
  urlDisallow?: string[]
  favicon?: string
  shortCode?: string
}

export const dataByPlatform: Record<Platform, PlatformConfig> = {
  [Platform.SOLAR_REVIEWS]: {
    shortCode: "sr",
    title: "SolarReviews",
    urlString: "solarreviews.com",
    urlFilter: "installers",
    urlDisallow: [],
    textColor: "text-blue-700",
    bgColor: "bg-blue-200",
    hasReviews: true,
    favicon: "/assets/signal-favicons/solarreviews.png",
  },
  [Platform.ENERGY_SAGE]: {
    shortCode: "es",
    title: "EnergySage",
    urlString: "energysage.com",
    urlFilter: "supplier",
    urlDisallow: ["gallery"],
    textColor: "text-orange-700",
    bgColor: "bg-orange-200",
    hasReviews: true,
    favicon: "/assets/signal-favicons/energysage.png",
  },
  [Platform.OHM_ANALYTICS]: {
    shortCode: "oa",
    title: "Ohm Analytics",
    urlString: "ohmanalytics.com",
    textColor: "text-purple-700",
    bgColor: "bg-gray-200",
    hasReviews: false,
  },
  [Platform.YELP]: {
    shortCode: "yp",
    title: "Yelp",
    urlString: "yelp.com",
    urlFilter: "biz",
    urlDisallow: ["/search"],
    textColor: "text-red-700",
    bgColor: "bg-red-200",
    hasReviews: true,
    favicon: "/assets/signal-favicons/yelp.png",
  },
  [Platform.BBB]: {
    shortCode: "bbb",
    title: "BBB",
    urlString: "bbb.org",
    urlFilter: "profile",
    urlDisallow: ["customer-reviews", "complaints"],
    textColor: "text-teal-700",
    bgColor: "bg-teal-200",
    hasReviews: true,
    favicon: "/assets/signal-favicons/bbb.png",
  },
  [Platform.GOOGLE]: {
    shortCode: "go",
    title: "Google",
    urlString: "google.com",
    textColor: "text-green-700",
    bgColor: "bg-green-200",
    hasReviews: true,
    favicon: "/assets/signal-favicons/google.png",
  },
}

export const PLATFORMS_WITH_REVIEWS = Object.keys(dataByPlatform).filter(
  (platform) => dataByPlatform[platform as Platform].hasReviews
)

export const getPlatformFromUrl = (url: string) => {
  return Object.entries(dataByPlatform).find(([, config]) =>
    url.includes(config.urlString)
  )?.[0] as Platform | undefined
}

export const getPlatformByShortCode = (
  shortCode: string
): Platform | undefined => {
  const normalizedShortCode = shortCode?.trim().toLowerCase()
  if (!normalizedShortCode) return undefined

  return (Object.values(Platform) as Platform[]).find(
    (platform) =>
      dataByPlatform[platform]?.shortCode?.toLowerCase() === normalizedShortCode
  )
}
